import { Injectable, signal } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { Observable } from "rxjs";
import { IBucketItem } from "../models/bucket-item.model";

@Injectable({
  providedIn: "root",
})
export class RowDataService {
  private readonly clickedRowData = signal<Partial<IBucketItem> | null>(null);
  private readonly rowDataObs = toObservable(this.clickedRowData);

  public getClickedRowData(): Observable<Partial<IBucketItem> | null> {
    return this.rowDataObs;
  }

  public setclickedRowData(data: Partial<IBucketItem> | null) {
    this.clickedRowData.set(data);
  }
}
